searchModule.factory("QuoteSearchResult",
    ['CustomerInfo', 'VehicleInfo', 'DealInfo',
    function(CustomerInfo, VehicleInfo, DealInfo) {

        var QuoteSearchResult = function() {
            this.quoteId = '';
            this.quoteSessionId = '';

            this.customer = new CustomerInfo();
            this.vehicle = new VehicleInfo(true);//ignoring inservice date request
            this.deal = new DealInfo();

            this.vehicleDetails = '';
            this.productName = '';
            this.coverageName = '';
            this.coverageTerm = '';
            this.retailAmount = 0.0;
            this.dealerAmount = 0.0;
            this.rateType = "";
            this.profit = 0.0;
            this.quoteStatusName = '';
            this.quoteDate = null;
            this.contractId = 0;
            this.contractStatusName = null;
            this.providerContractId = null;
            this.dealNumber = '';
        };

        QuoteSearchResult.prototype.populateDataFromTLCAPI = function(data) {
            this.contractId = data.contractId ? data.contractId : 0;
            this.providerContractId = data.providerContractId ? data.providerContractId : null;
            this.contractStatusName = data.contractStatusName;
            this.quoteId = data.quoteId;
            this.quoteSessionId = data.quoteSessionId;
            this.customer.BuyerInfo.lastName = data.customerLastName;
            this.customer.BuyerInfo.middleName = data.customerMiddleName || '';
            this.customer.BuyerInfo.firstName = data.customerFirstName;
            this.customer.BuyerInfo.email = data.customerEmail || '';
            this.customer.BusinessInfo.businessName = data.businessName || '';

            this.vehicle.dateOfSale = data.dateOfSale;
            this.vehicle.vin = (data.vehicleIdNumber || data.vehicleVIN || '').toUpperCase();
            this.vehicle.odometer = data.odometer;
            if (data.vehicleYear && data.vehicleMake && data.vehicleModel)
                this.vehicleDetails = data.vehicleYear + ' ' + data.vehicleMake + ' ' + data.vehicleModel;
            else if (data.vehicleDetails && data.vehicleDetails.trim() != '0' && data.vehicleDetails.trim() != '' )
                this.vehicleDetails = data.vehicleDetails;
            else
                this.vehicleDetails = this.vehicle.vin;
            this.productName = data.productName;
            this.coverageName = data.coverageName;
            this.coverageTerm = data.coverageTerm;
            this.retailAmount = data.retailAmount;
            this.dealerAmount = data.dealerAmount;
            this.rateType = data.rateType;
            this.profit = data.profit;
            this.quoteStatusName = data.quoteStatusName;
            this.dealNumber = data.dealNumber;
            this.quoteDate = data.quoteDate;

            this.$$backingData = data;

            return this.quoteId;
        };

        QuoteSearchResult.prototype.coalesce = function(mergeFrom) {
            // right now this does nothing
            // It is a hook, in case in the future we want to combine information that came from different sources.
            // For example, from Span vs from Menu.  In search results we remove duplicates. This method anticipates
            // the possibility that a result that is considered a duplicate, nevertheless may contain some pieces
            // of information that are not in the search result that replaces it.
        };

        QuoteSearchResult.prototype.areResultsEquivalent = function(itemToCompare) {
            if (this.quoteSessionId && itemToCompare.quoteSessionId) {
                // Both have a quote id. We can decide based on that alone.
                return this.quoteSessionId == itemToCompare.quoteSessionId;
            }

            if (this.customer.BuyerInfo.lastName.toUpperCase() !=  itemToCompare.customer.BuyerInfo.lastName.toUpperCase())
                return false;

            if (this.customer.BuyerInfo.firstName.toUpperCase() !=  itemToCompare.customer.BuyerInfo.firstName.toUpperCase())
                return false;

            if (!haveEquivalentVehicle(this, itemToCompare))
                return false;

            if (this.vehicle.dateOfSale != itemToCompare.vehicle.dateOfSale)
                return false;

            if (this.vehicle.odometer != itemToCompare.vehicle.odometer)
                return false;

            return true;
        }

        function haveEquivalentVehicle(item, itemToCompare) {
            if (item.vehicle.vin && itemToCompare.vehicle.vin) {
                // both have a vin, so can decide based on vin alone
                return item.vehicle.vin == itemToCompare.vehicle.vin;
            }

            // at least one vehicle does not have a vin, so decide based on Model / Make / Year
            return item.vehicleDetails.toUpperCase() != itemToCompare.vehicleDetails.toUpperCase();
        }


        return QuoteSearchResult;
    }
]);
